export const KYC_STATUSES = {
  UNKNOWN: 'UNKNOWN',
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
}

export const KYC_SELECT_STATUSES = [
  { value: 'UNKNOWN', label: 'ไม่ระบุ' },
  { value: 'PENDING', label: 'รอตรวจสอบ' },
  { value: 'APPROVED', label: 'อนุมัติ' },
  { value: 'REJECTED', label: 'ปฏิเสธ' },
]

export const KYC_STATUSES_COLOR_LIGHT = {
  [KYC_STATUSES.PENDING]: 'warning light',
  [KYC_STATUSES.APPROVED]: 'success light',
  [KYC_STATUSES.REJECTED]: 'danger light',
}

export const KYC_STATUSES_COLOR = {
  [KYC_STATUSES.PENDING]: 'warning',
  [KYC_STATUSES.APPROVED]: 'success',
  [KYC_STATUSES.REJECTED]: 'danger',
}

export const KYC_STATUSES_TEXT_COLOR = {
  [KYC_STATUSES.PENDING]: 'text-warning',
  [KYC_STATUSES.APPROVED]: 'text-success',
  [KYC_STATUSES.REJECTED]: 'text-danger',
}

export const KYC_DECISION = [
  { value: 'APPROVED', label: 'ถูกต้อง' },
  { value: 'REJECTED', label: 'ไม่ถูกต้อง' },
]

export const KYC_CUSTOMER_CITIZENSHIP = {
  THAI: 'THAI',
  FOREIGNER: 'FOREIGNER',
}

export const KYC_CARD_TYPE = {
  THAI_ID: 'THAI_ID',
  PASSPORT: 'PASSPORT',
  WORK_PERMIT: 'WORK_PERMIT',
}

export const KYC_CITIZENSHIP_OPTIONS = [
  { value: KYC_CUSTOMER_CITIZENSHIP.THAI, label: 'คนไทย' },
  { value: KYC_CUSTOMER_CITIZENSHIP.FOREIGNER, label: 'ชาวต่างชาติ' },
]

export const KYC_STAY = {
  WORKING_IN_COUNTRY: 'WORKING_IN_COUNTRY',
  TRAVELING_IN_COUNTRY: 'TRAVELING_IN_COUNTRY',
  OUT_OF_COUNTRY: 'OUT_OF_COUNTRY',
  CUSTOM: 'CUSTOM',
}

export const KYC_THAILAND_STAY_OPTIONS = [
  { value: KYC_STAY.WORKING_IN_COUNTRY, label: 'ทำงานในประเทศไทย' },
  { value: KYC_STAY.TRAVELING_IN_COUNTRY, label: 'มาท่องเที่ยว' },
  { value: KYC_STAY.NOT_IN_THAILAND, label: 'ไม่ได้อยู่ในประเทศไทย' },
  { value: KYC_STAY.CUSTOM, label: 'อื่นๆ' },
]

export const KYC_REASON_ID_CARD = [
  'กรุณาอัปโหลดภาพที่ชัดเจน ไม่มีอะไรปิดบัง',
  'กรุณาตรวจสอบข้อมูล ชื่อ นามสกุล วันเกิด วันที่ออกบัตร วันบัตรหมดอายุ ให้ถูกต้อง',
]

export const KYC_REASON_BANK = [
  'กรุณาอัปโหลดภาพที่ชัดเจน ไม่มีอะไรปิดบัง',
  'กรุณาตรวจสอบข้อมูล ธนาคาร เลขบัญชีธนาคาร ให้ถูกต้อง',
]
